import React, { useState, useEffect } from 'react';
import apas from '../Assests/apas.png';
import testleft from '../Assests/testleft.png';
import testright from '../Assests/testright.png';
import Arrow from '../Assests/Group 2 (3).png';
import Aos from 'aos';
import 'aos/dist/aos.css';


const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        // Fetch testimonials data from the backend API
        const fetchTestimonials = async () => {
            try {
                const response = await fetch('https://sirichandhanak-backend.vercel.app/api/testimonials');
                if (!response.ok) {
                    throw new Error('Failed to fetch testimonials');
                }
                const data = await response.json();
                console.log(data);
                const reversedData = data.reverse(); 
                setTestimonials(reversedData);
                setTestimonials(data);
            } catch (error) {
                console.error('Error fetching testimonials:', error);
            }
        };

        fetchTestimonials();
    }, []);

    useEffect(() => {
        Aos.init({ duration: 1000 });
      }, []);

    const nextSlide = () => {
        setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    };

    if (testimonials.length === 0) {
        return <div></div>;
    }

    const StarRating = ({ rating }) => {
        const totalStars = 5;
        const filledStars = Math.round(rating); // Assuming rating is out of 5
        const emptyStars = totalStars - filledStars;
    
        return (
            <div className="flex">
                {Array(filledStars).fill(<span className="text-[#E4B379] text-2xl">★</span>)}
                {Array(emptyStars).fill(<span className="text-gray-400 text-2xl">★</span>)}
            </div>
        );
    };


    return (
        <div className="my-20 md:my-32">
            <div className='md:flex'>
            <div className='ml-10 mr-10 md:ml-96 md:mr-10 md:hidden' data-aos='fade-left'>
                    <h2 className="text-3xl text-center md:text-6xl md:text-right font-bold text-white mb-8">What</h2>
                    <h1 className='text-4xl md:text-7xl text-center md:text-none font-extrabold text-white '>They Say</h1>
                    <img className='mt-4 ml-14 md:ml-20' src={Arrow} alt='arrow' />
                </div>

                <div className="relative w-[300px] md:w-[600px] h-[500px] md:h-[350px] bg-[#3D3D3D] md:ml-20 md:mr-0 mx-2 rounded-2xl mt-10 md:mt-0  " data-aos='fade-right'>
                    <div className="overflow-hidden rounded-xl md:p-6 p-2 text-white">
                        {testimonials.map((testimonial, index) => (
                            <div
                                key={index}
                                className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${index === current ? 'opacity-100' : 'opacity-0'
                                    }`}
                            >
                                <img src={apas} alt="apas" className="md:h-12 md:mt-4 h-10 mt-2 mx-auto mb-4" />
                                <p className="text-xl font-light text-justify mx-20">{testimonial.description}</p>
                                {/* <p className='mt-4 mx-20'>{testimonial.rating}</p> */}
                                <div className="flex justify-center mt-4">
                                    <StarRating rating={testimonial.rating} />
                                </div>
                                <div className='flex justify-between'>
                                    <button onClick={prevSlide} className='ml-10 cursor-pointer'>
                                    <img src={testleft} alt="left" className="h-10 mt-4" />
                                    </button>
                                    <div className="">
                                        <img src={testimonial.imageUrl} alt="profile" className="h-16 w-16 rounded-full mx-auto mb-2" />
                                        <h1 className="text-xl flex justify-center">{testimonial.title}</h1>
                                    </div>
                                    <button onClick={nextSlide} className='mr-10'>
                                    <img src={testright} alt="right" className="h-10 mt-4" />
                                    </button>
                                </div>
                                <div className="flex justify-center mt-4 space-x-4">
                                    
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='ml-80 hidden lg:block' data-aos='fade-left'>
                    <h2 className="text-6xl text-right font-bold text-white mb-8">What</h2>
                    <h1 className='text-7xl font-extrabold text-white '>They Say</h1>
                    <img className='mt-4 ml-20' src={Arrow} alt='arrow' />
                </div>

            </div>
            <div className="mt-4 ml-[370px] flex space-x-2">
                {testimonials.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrent(index)}
                        className={`h-2 w-2 rounded-full ${index === current ? 'bg-gray-500' : 'bg-gray-300'
                            }`}
                    ></button>
                ))}
            </div>
        </div>
    );
};

export default Testimonials;